"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@formily/core");
var shared_1 = require("@formily/shared");
var useForceUpdate_1 = require("./useForceUpdate");
var shared_2 = require("../shared");
var context_1 = __importDefault(require("../context"));
var INSPECT_PROPS_KEYS = ['props', 'visible', 'display'];
exports.useVirtualField = function (options) {
    var forceUpdate = useForceUpdate_1.useForceUpdate();
    var ref = react_1.useRef({
        field: null,
        unmounted: false,
        subscriberId: null,
        uid: null
    });
    var form = react_1.useContext(context_1.default);
    if (!form) {
        throw new Error('Form object cannot be found from context.');
    }
    react_1.useMemo(function () {
        var initialized = false;
        ref.current.field = form.registerVirtualField(options);
        ref.current.subscriberId = ref.current.field.subscribe(function () {
            if (ref.current.unmounted)
                return;
            if (initialized) {
                forceUpdate();
            }
        });
        ref.current.uid = Symbol();
        initialized = true;
    }, [options.name, options.path]);
    react_1.useEffect(function () {
        var cacheProps = ref.current.field.getCache(ref.current.uid);
        if (cacheProps) {
            var props_1 = shared_2.inspectChanged(cacheProps, options, INSPECT_PROPS_KEYS);
            if (props_1) {
                ref.current.field.setState(function (state) {
                    shared_1.merge(state, props_1, {
                        assign: true,
                        arrayMerge: function (target, source) { return source; }
                    });
                });
                ref.current.field.setCache(ref.current.uid, options);
            }
        }
        else {
            ref.current.field.setCache(ref.current.uid, options);
        }
    });
    react_1.useEffect(function () {
        ref.current.field.setState(function (state) {
            state.mounted = true;
        }, !ref.current.field.state.unmounted);
        form.notify(core_1.LifeCycleTypes.ON_FIELD_MOUNT, ref.current.field);
        ref.current.unmounted = false;
        return function () {
            ref.current.field.removeCache(ref.current.uid);
            ref.current.unmounted = true;
            ref.current.field.unsubscribe(ref.current.subscriberId);
            ref.current.field.setState(function (state) {
                state.unmounted = true;
            });
        };
    }, []);
    var state = ref.current.field.getState();
    return {
        state: state,
        field: ref.current.field,
        form: form,
        props: state.props
    };
};
exports.default = exports.useVirtualField;
